export default {
  S_SKTTOWER: {
    logo: 'logo_skttower.png',
    className: 'SK',
    contentsClassName: 'contents'
  },
  S_DONGSAN: {
    logo: 'logo_dongsan.png',
    className: 'DONGSAN',
    contentsClassName: 'contents'
  },
  S_DARAE: {
    logo: 'logo_darae.png',
    className: 'DARAE',
    contentsClassName: 'h_middle contents'
  },
  S_GALLERIA_GG: {
    logo: 'logo_galleria_gg.png',
    className: 'DARAE',
    contentsClassName: 'h_middle contents'
  },
  S_DESIAN_GM: {
    logo: 'logo_desian_gm.png',
    className: 'DARAE',
    contentsClassName: 'h_middle contents'
  },
  S_AINWH: {
    logo: 'logo_ainwh.png',
    className: 'DARAE',
    contentsClassName: 'h_middle contents'
  }
};
